import { toast } from 'sonner';

export const toastBlue = (msg) => toast(msg, { 
  style: { background: '#eff6ff', border: '1px solid #93c5fd', color: '#1d4ed8' }
});
